/**
 * @generated SignedSource<<5567a39166b30a4ff19c7b0a56c6571b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PriorityGroupHeader$data = {
  readonly displayName: string;
  readonly priority: {
    readonly iconUrl: AGG$URL | null | undefined;
  };
  readonly " $fragmentType": "PriorityGroupHeader";
};
export type PriorityGroupHeader$key = {
  readonly " $data"?: PriorityGroupHeader$data;
  readonly " $fragmentSpreads": FragmentRefs<"PriorityGroupHeader">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "PriorityGroupHeader",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "displayName"
    },
    {
      "concreteType": "JiraPriority",
      "kind": "LinkedField",
      "name": "priority",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "iconUrl"
        }
      ]
    }
  ],
  "type": "JiraJqlPriorityFieldValue"
};

(node as any).hash = "005933ac841dded3cda21a36de7b85e9";

export default node;
